import React, { Fragment } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { date, formatDate } from "../../../utilities/utils";
import DisplayEmployeeBlock from "../DisplayEmployeeBlock";
import DropdownComponent from "../../../containers/Dropdown";
import { STDLTDDRPDATA, ALERT_ERROR_MESSAGE } from "../../../App.config";
import TermsAndConditionModalPopup from "../../../containers/Std/TermsAndCondition";
import ToggleComponent from "../../../containers/Common/ToggleComponent";
import FileSvg from "../../../images/file.svg";
import CloseSvg from "../../../images/close.svg";
import Wheelchair from "../../../images/wheelchair.svg";
import UploadSvg from "../../../images/upload.svg";
import heart from "../../../images/heart.svg";
import AlertError from "../../../containers/Common/AlertError";
import AttachmentTable from "../AttachmentTable";
import backArrow from "../../../images/back-arrow.svg";
import moment from "moment";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";

const EmployerDetailsFinal = ({
  onDateChange,
  state,
  handleChanges,
  onSubmit,
  previousStep,
  props,
  onDropDownChange,
  onStdLtdDropdownChange,
  onStdLtdDateChange,
  addMoreElement,
  removeElement,
  download,
  handleFileUpload,
  removeFile,
  attachmentRef,
  addDescription,
  isFormValid,
}) => {
  // const openModal = () => {
  //   props.openSetModalAction(
  //     <TermsAndConditionModalPopup context={props.context} />
  //   );
  // };
  return (
    <>
      {/* {!isFormValid && <AlertError message={ALERT_ERROR_MESSAGE} />} */}
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={heart} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t("STD-Employer-Statement.form.heading.text")}
                </span>
                {/* <legend>
                  {props.context.t(
                    "STD-Employer-Statement.form.subheading.text"
                  )}
                  <em>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading2.text"
                    )}
                  </em>
                </legend> */}
              </h2>
            </div>
            <div className="panel-content">
              <DisplayEmployeeBlock context={props.context} state={state} />

              <div className="Custom-form">
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading4.text"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques8"
                        )}
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder=""
                        name="informationForReview"
                        value={state.informationForReview.value}
                        onChange={handleChanges}
                      />
                    </div>
                  </div>
                </div>

                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading5.text"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques3.1"
                        )}
                      </label>
                    </div>
                  </div>
                  {state.previousStdLtd.value.map((element, index) => (
                    <Fragment key={index}>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Type-Of-Cases"
                            )}
                          </label>
                          <br />
                          <DropdownComponent
                            name="stdLtd"
                            id="stdLtd"
                            options={STDLTDDRPDATA}
                            isMultiSelect={false}
                            option_key="stdLtdId"
                            option_display="stdLtdName"
                            onChange={(e) => {
                              onStdLtdDropdownChange(e, index);
                            }}
                            values={element.stdLtd}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                        <div className="form-group Date-feild">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Cases"
                            )}
                            {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                          </label>
                          <CustomDatePicker
                            //maxDate={moment().toDate()}
                            id="stdLtdDate"
                            max
                            selected={element.stdLtdDate}
                            onChange={(e) => {
                              onStdLtdDateChange(e, "stdLtdDate", index);
                            }}
                            placeholderText={props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Cases"
                            )}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                        <div className="form-group Date-feild">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Rtw"
                            )}
                            {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                          </label>
                          <CustomDatePicker
                            id="stdLtdRtwDate"
                            selected={element.stdLtdRtwDate}
                            onChange={(e) => {
                              onStdLtdDateChange(e, "stdLtdRtwDate", index);
                            }}
                            placeholderText={props.context.t(
                              "STD-Employer-Statement.form.Absence-Details.label.text.Date-Of-Rtw"
                            )}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!element.default && (
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2">
                          <input
                            type="button"
                            className="btn btn-danger margin-top-28"
                            onClick={(e) => {
                              e.preventDefault();
                              removeElement(index);
                            }}
                            value={props.context.t(
                              "STD-Employer-Statement.form.button.remove"
                            )}
                          />
                        </div>
                      )}
                    </Fragment>
                  ))}
                  <div className="col-12 col-sm-12 col-md-12 col-lg-2">
                    <input
                      type="button"
                      className="btn btn-primary margin-top-28"
                      onClick={(e) => {
                        e.preventDefault();
                        addMoreElement();
                      }}
                      value={props.context.t(
                        "STD-Employer-Statement.form.button.add-More"
                      )}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques4"
                        )}
                      </label>
                      <ToggleComponent
                        name="observedChanges"
                        isActive={state.observedChanges.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                    <div>
                      {state.observedChanges.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherSpecifyHere"
                              )}
                              name="isObservedChanges"
                              value={state.isObservedChanges.value}
                              onChange={handleChanges}
                            />
                            {state.isObservedChanges?.error && (
                              <span className="error">
                                {state.isObservedChanges.error}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques5"
                        )}
                      </label>
                      <ToggleComponent
                        name="behaviorChanges"
                        isActive={state.behaviorChanges.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                    <div>
                      {state.behaviorChanges.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherSpecifyHere"
                              )}
                              name="isBehaviorChanges"
                              value={state.isBehaviorChanges.value}
                              onChange={handleChanges}
                            />
                            {state.isBehaviorChanges?.error && (
                              <span className="error">
                                {state.isBehaviorChanges.error}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Absence-Details.label.text.Ques7"
                        )}
                      </label>
                      <ToggleComponent
                        name="discuss"
                        isActive={state.discuss.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                  </div>
                </div>
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading7.text"
                    )}
                  </span>
                </h2>
                <div className="Check-box">
                  <div>
                    <input
                      className="styled-checkbox"
                      type="checkbox"
                      id="administerPayroll"
                      name="administerPayroll"
                      onChange={handleChanges}
                      checked={state.administerPayroll.value}
                    />
                    <label htmlFor="administerPayroll">
                      <span>
                        {props.context.t(
                          "STD-Employer-Statement.form.Employer-Details.label.text.Administering-The-payroll"
                        )}
                      </span>
                    </label>
                  </div>
                </div>
                {state.administerPayroll.value ? (
                  <>
                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Federal-Net-Exemption"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="federalNetExemptionCode"
                            value={state.federalNetExemptionCode.value}
                            ref={state.federalNetExemptionCode.ref}
                            onChange={handleChanges}
                          />
                          {state.federalNetExemptionCode?.error && (
                            <span className="error">
                              {state.federalNetExemptionCode.error}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Net-Claim-Exemption"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="federalNetExemption"
                            value={state.federalNetExemption.value}
                            ref={state.federalNetExemption.ref}
                            onChange={handleChanges}
                          />
                          {state.federalNetExemption?.error && (
                            <span className="error">
                              {state.federalNetExemption.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Provincial-Net-Exemption"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="provincialNetExemptionCode"
                            value={state.provincialNetExemptionCode.value}
                            ref={state.provincialNetExemptionCode.ref}
                            onChange={handleChanges}
                          />
                          {state.provincialNetExemptionCode?.error && (
                            <span className="error">
                              {state.provincialNetExemptionCode.error}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Net-Claim-Exemption"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="provincialNetExemption"
                            value={state.provincialNetExemption.value}
                            ref={state.provincialNetExemption.ref}
                            onChange={handleChanges}
                          />
                          {state.provincialNetExemption?.error && (
                            <span className="error">
                              {state.provincialNetExemption.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-2 col-lg-2">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="salary"
                            value={state.salary.value}
                            ref={state.salary.ref}
                            onChange={handleChanges}
                          />
                          {state.salary?.error && (
                            <span className="error">{state.salary.error}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary-Per"
                            )}
                          </label>
                          <ul>
                            <li className="Radio-box">
                              <div className="check-col">
                                <input
                                  type="radio"
                                  id="By-Hour"
                                  name="salaryPer"
                                  value="Hour"
                                  checked={state.salaryPer.value === "Hour"}
                                  onChange={handleChanges}
                                />
                                <label htmlFor="By-Hour">
                                  {props.context.t(
                                    "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary-Per-Hour"
                                  )}
                                </label>
                              </div>
                              <div className="check-col">
                                <input
                                  type="radio"
                                  id="By-Day"
                                  name="salaryPer"
                                  value="Day"
                                  checked={state.salaryPer.value === "Day"}
                                  onChange={handleChanges}
                                />
                                <label htmlFor="By-Day">
                                  {props.context.t(
                                    "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary-Per-Day"
                                  )}
                                </label>
                              </div>
                              <div className="check-col">
                                <input
                                  type="radio"
                                  id="By-Week"
                                  name="salaryPer"
                                  value="Week"
                                  checked={state.salaryPer.value === "Week"}
                                  onChange={handleChanges}
                                />
                                <label htmlFor="By-Week">
                                  {props.context.t(
                                    "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary-Per-Week"
                                  )}
                                </label>
                              </div>
                              <div className="check-col">
                                <input
                                  type="radio"
                                  id="By-Month"
                                  name="salaryPer"
                                  value="Month"
                                  checked={state.salaryPer.value === "Month"}
                                  onChange={handleChanges}
                                />
                                <label htmlFor="By-Month">
                                  {props.context.t(
                                    "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary-Per-Month"
                                  )}
                                </label>
                              </div>
                              <div className="check-col">
                                <input
                                  type="radio"
                                  id="By-Year"
                                  name="salaryPer"
                                  value="Year"
                                  checked={state.salaryPer.value === "Year"}
                                  onChange={handleChanges}
                                />
                                <label htmlFor="By-Year">
                                  {props.context.t(
                                    "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Salary-Per-Year"
                                  )}
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Pay-Frequency"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="payFrequency"
                            value={state.payFrequency.value}
                            ref={state.payFrequency.ref}
                            onChange={handleChanges}
                          />
                          {state.payFrequency?.error && (
                            <span className="error">
                              {state.payFrequency.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3 col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group Ctm-rdo rdo1">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Total-Paid-Out"
                            )}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.CPP"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="totalPaidOutCpp"
                            value={state.totalPaidOutCpp.value}
                            ref={state.totalPaidOutCpp.ref}
                            onChange={handleChanges}
                          />
                          {state.totalPaidOutCpp?.error && (
                            <span className="error">
                              {state.totalPaidOutCpp.error}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.EI"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="totalPaidOutEi"
                            value={state.totalPaidOutEi.value}
                            ref={state.totalPaidOutEi.ref}
                            onChange={handleChanges}
                          />
                          {state.totalPaidOutEi?.error && (
                            <span className="error">
                              {state.totalPaidOutEi.error}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.QPIP"
                            )}
                            {/* <span size="5" className="error-star">
                              *
                            </span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="totalPaidOutQpip"
                            value={state.totalPaidOutQpip.value}
                            ref={state.totalPaidOutQpip.ref}
                            onChange={handleChanges}
                          />
                          {state.totalPaidOutQpip?.error && (
                            <span className="error">
                              {state.totalPaidOutQpip.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3 col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group Ctm-rdo rdo1">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Indicate-Only-If-maxed"
                            )}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.CPP"
                            )}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="maxedCpp"
                            value={state.maxedCpp.value}
                            onChange={handleChanges}
                          />
                          {state.maxedCpp?.error && (
                            <span className="error">
                              {state.maxedCpp.error}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.EI"
                            )}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="maxedEi"
                            value={state.maxedEi.value}
                            onChange={handleChanges}
                          />
                          {state.maxedEi?.error && (
                            <span className="error">{state.maxedEi.error}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3 col-lg-3">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.QPIP"
                            )}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="maxedQpip"
                            value={state.maxedQpip.value}
                            onChange={handleChanges}
                          />
                          {state.maxedQpip?.error && (
                            <span className="error">
                              {state.maxedQpip.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Select-Add-payroll-verbiage"
                            )}
                          </label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="payrollVerbiage"
                            value={state.payrollVerbiage.value}
                            onChange={handleChanges}
                            ref={state.payrollVerbiage.ref}
                          />
                          {state.payrollVerbiage?.error && (
                            <span className="error">
                              {state.payrollVerbiage.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group Ctm-rdo">
                          <label htmlFor="">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employer-Details.payroll.label.text.Additional-Notes"
                            )}
                          </label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                          <textarea
                            type="text"
                            className="form-control"
                            placeholder=""
                            name="additionalNotes"
                            value={state.additionalNotes.value}
                            onChange={handleChanges}
                          />
                          {state.additionalNotes?.error && (
                            <span className="error">
                              {state.additionalNotes.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                {/* Additional Information */}
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading8.text"
                    )}
                  </span>
                </h2>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="form-group">
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder=""
                      name="additionalNotesAdd"
                      value={state.additionalNotesAdd.value}
                      onChange={handleChanges}
                    />
                    {state.additionalNotesAdd?.error && (
                      <span className="error">
                        {state.additionalNotesAdd.error}
                      </span>
                    )}
                  </div>
                </div>

                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading6.text"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-xl-4 col-md-6 col-12">
                    <div className="form-group">
                      {/* <label htmlFor="">Attachments [Upload Attachments]</label> */}
                      <div className="upload-btn-wrapper form-control">
                        <button tabIndex="-1" className="upload-btn">
                          <img tabIndex="-1" src={UploadSvg} alt="" />
                          {props.context.t(
                            "STD-Employer-Statement.form.Employer-Details.label.text.Upload"
                          )}
                        </button>
                        <input
                          onChange={handleFileUpload}
                          type="file"
                          tabIndex="-1"
                          name="attachment"
                          ref={attachmentRef}
                        />
                      </div>
                      <small>
                        {props.context.t(
                          "STD-Employer-Statement.form.Employer-Details.label.text.File-Format"
                        )}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  {Array.isArray(props.attachment) &&
                    props.attachment.length ? (
                      <AttachmentTable
                        attachment={props.attachment}
                        download={download}
                        removeFile={removeFile}
                        addDescription={addDescription}
                      />
                    ) : null}
                </div>



                <div className="Check-box">
                  <div>
                    <input
                      className="styled-checkbox"
                      type="checkbox"
                      id="termsAndCondition"
                      name="termsAndCondition"
                      onChange={handleChanges}
                      checked={state.termsAndCondition.value}
                    />
                    <label htmlFor="termsAndCondition">
                      <span>
                        {props.context.t(
                          "STD-Employer-Statement.form.Employer-Details.label.text.Terms-And-Condition"
                        )}
                      </span>
                    </label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    {/* <div className="panel-footer margn-50">
                      <a
                        tabIndex="0"
                        onClick={previousStep}
                        className="btn btn-primary"
                      >
                        {props.context.t(
                          "STD-Employer-Statement.form.button.previous"
                        )}
                      </a>
                    </div> */}
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="panel-footer text-right margn-50">
                      <a
                        tabIndex="0"
                        onClick={() => onSubmit(true, false)}
                        className={
                          state.termsAndCondition.value
                            ? "btn btn-primary"
                            : "btn btn-primary disabled"
                        }
                      >
                        {props.context.t(
                          "STD-Employer-Statement.form.button.save"
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployerDetailsFinal;
